import { ProjectMemberGeneratedEntity } from "./generated/ProjectMemberGeneratedEntity";

export abstract class ProjectMemberEntity extends ProjectMemberGeneratedEntity {
    // Comment to preserve new line
}
